import { OverlayContainer } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { WhiteLabelJsonService } from './core/services/white-label-json.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'se-portalui';
  LoaderLogoJsonPath = null;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  constructor(
    private whiteLabelService: WhiteLabelJsonService,
    overlayContainer: OverlayContainer
  ) {
    overlayContainer.getContainerElement().classList.add('alt-theme');
  }

  async ngAfterViewInit() {
    this.LoaderLogoJsonPath = await this.whiteLabelService.getKeyJsonParameter(
      'loader_logo'
    );

    this.favIcon.href = await this.whiteLabelService.getKeyJsonParameter(
      'logo_mini_login'
    );
  }
}
